module.exports = __webpack_public_path__ + "static/media/logo_transparent.2383d011.png";